<template>
  <div>
    <el-form label-position="top" label-width="90px">
      <div  v-if="setType==='base'" class="option" >
        <el-form-item label="请选择该节点的抄送人" prop="text" class="user-type">
          <div class="radio-sub-name">
            <div class="name">常用抄送人</div>
            <div class="name">主管</div>
          </div>
          <el-radio-group v-model="nodeProps.assignedType" class="radio-group" @change="changeAssignedType(nodeProps.assignedType)">
            <el-radio v-for="(t,index) in approvalTypes" :label="t.type" :key="t.type" :class="'radio-'+index" ><span class="radio-name">{{ t.name }}</span></el-radio>
          </el-radio-group>
          <div v-if="nodeProps.assignedType === 'ASSIGN_USER'">
            <el-select v-model="nodeProps.assignedUser" @click.native="selectUser" value-key="name"
                        class="select-u" placeholder="指定成员"
                        size="medium" multiple popper-class="hidden">
              <el-option v-for="(wc, index) in nodeProps.assignedUser" :label="wc.name" :key="index" :value="wc"></el-option>
            </el-select>
          </div>
          <div v-else-if="nodeProps.assignedType === 'LEADER'">
            <span class="item-desc">发起人直接上级将作为抄送人进行抄送</span>
          </div>
          <div v-else-if="nodeProps.assignedType === 'DEPT_LEADER'">
            <span class="item-desc">发起人的
              <el-select v-model="nodeProps.leader.level" size="small" class="select-level">
                <el-option label="第2级主管" :value="2"></el-option>
                <el-option label="第3级主管" :value="3"></el-option>
              </el-select>
            </span>
          </div>
          <div v-else-if="nodeProps.assignedType === 'ROLE'">
            <el-select v-model="nodeProps.role" @click.native="selectRole" value-key="name"
                        class="select-u" placeholder="指定角色"
                        size="medium" multiple popper-class="hidden">
              <el-option v-for="(wc, index) in nodeProps.role" :label="wc.name" :key="index" :value="wc"></el-option>
            </el-select>
          </div>
      </el-form-item>
        <!-- <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectOrg" plain>选择抄送人</el-button>
        <org-items v-model="select"/>
        <org-picker multiple ref="orgPicker" :selected="select" @ok="selected"/> -->
        <!-- <el-form-item label="选择抄送人" prop="text" class="user-type">
          <el-select v-model="select" @click.native="selectUser" @remove-tag="removeTag" value-key="name"
                    class="select-u" placeholder="选择抄送人"
                    size="medium" multiple popper-class="hidden">
            <el-option v-for="(wc, index) in select" :label="wc.name" :key="index" :value="wc"></el-option>
          </el-select>
          <org-picker title="选择抄送人" multiple ref="orgPicker" :selected="select" @ok="selected"/>
        </el-form-item> -->
        
      </div>

      <div  v-else-if="setType==='pro'" class="option">
        <!-- <el-checkbox  v-model="config.shouldAdd"><span class="radio-name">允许发起人添加抄送人</span></el-checkbox> -->
          <div class="user-type-switch">
            <div class="label">允许发起人添加抄送人</div>
            <el-switch v-model="config.shouldAdd" active-color="#00B498" inactive-color="#E4F7F4"></el-switch>
          </div>
          <div class="tips">开启后，发起人可自行添加抄送人。</div>
        </div>
    </el-form>
    <org-picker :title="pickerTitle" multiple ref="orgPicker" @ok="selected" />
  </div>
</template>

<script>
import OrgPicker from "@/components/OrgPicker";
import OrgItems from "../OrgItems";

export default {
  name: "CcNodeConfig.vue",
  components: {OrgPicker, OrgItems},
  props:{
    config:{
      type: Object,
      default: ()=>{
        return {}
      }
    },
    setType:{
      type: String,
      default: 'base'
    }
  },
  computed:{
    nodeProps() {
      return this.$store.state.selectedNode.props
    },
    select: {
      get(){
        return this.config.assignedUser || []
      },
      set(val){
        this.config.assignedUser = val
      }
    }
  },
  data() {
    return {
      pickerTitle:'',
      pickerType:'',
      approvalTypes: [
        
        {name: '指定成员', type: 'ASSIGN_USER'},
        {name: '直接上级', type: 'LEADER'},// 右边1
        {name: '角色', type: 'ROLE'},
        {name: '部门主管', type: 'DEPT_LEADER'},// 右边2
      ]
    }
  },
  methods: {
    // selectOrg() {
    //   this.$refs.orgPicker.show()
    // },
    // selected(select) {
    //   console.log(select)
    //   this.select = Object.assign([], select)
    // },
    // removeOrgItem(index){
    //   this.select.splice(index, 1)
    // },
    // 指定成员
    selectUser() {
      this.pickerTitle = '指定成员'
      this.pickerType = 'user'
      this.$refs.orgPicker.show(this.select,this.pickerType)
    },
    // 指定角色
    selectRole() {
      this.pickerTitle = '指定角色'
      this.pickerType = 'role'
      this.$refs.orgPicker.show(this.nodeProps.role,this.pickerType)
    },
    // 选中人员回显
    selected(value) {
      console.log(value)
      if(this.pickerType==='user'){
        let key  = 'assignedUser'
        this.$store.commit("updateSelectedNode",{key,value});
      }else if(this.pickerType==='role'){
        let key  = 'role'
        this.$store.commit("updateSelectedNode",{key,value});
      }
       this.$bus.$emit('updateNodeText');
    },
    removeTag(item){
    },
    // 切换成员清空
    changeAssignedType(type){
      if (type !== 'ASSIGN_USER') {
        this.$store.commit("updateSelectedNode", { key: 'assignedUser', value: [] });
      }
      if (type !== 'ROLE') {
        this.$store.commit("updateSelectedNode", { key: 'role', value: [] });
      }
       if (type == 'DEPT_LEADER') {
          this.$store.commit("updateSelectedNode", { key: 'leader', value: {level:2} });
      }else if(type == 'LEADER') {
          this.$store.commit("updateSelectedNode", { key: 'leader', value: {level:1} });
      }
      this.$bus.$emit('updateNodeText');
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-sub-name{
  display: inline-flex;
  width: 360px;
  line-height: 1;
  .name{
    width: 50%;
  }
}
.radio-name{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #2F3030;
  }
.user-type {
  /deep/ .el-form-item__label {
    padding-bottom: 2px;
    line-height: 25px;
  font-weight: bold;
  font-family: PingFang SC, PingFang SC;
  color: #2F3030;

  }
  .radio-group{
    width: 360px;
  }
  /deep/ .el-radio {
    width: 100%;
    // margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 0;
    &.radio-0,
    &.radio-1,
    &.radio-2,
    &.radio-3{
      float: left;
      width: 50%;
    }
  }
}
.user-type-switch{
  display: inline-flex;
  align-items: center;
  .label {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #2F3030;
    padding: 2px 0 6px 0;
    line-height:21px;
    margin-right: 4px;
  }
}
.tips{
    color:#939696;
    font-size: 14px;
  }
/deep/ .select-u{
  width: 100%;
}
.select-level{
  /deep/.el-input__inner{
    padding-left: 8px;
    font-size: 14px;
  }
}
// .option{
//   color: #606266;
//   margin-top: 20px;
//   font-size: small;
// }

// .desc{
//   font-size: small;
//   color: #8c8c8c;
// }
// .org-item{
//   margin: 5px;
// }
// .radio-name{
//     font-family: PingFang SC, PingFang SC;
//     font-weight: 400;
//     font-size: 14px;
//     color: #2F3030;
//   }
</style>
